import axios from 'axios';
import { useCallback } from 'react';

const AZURE_MAPS_API_GEOCODER_URL = 'https://atlas.microsoft.com/search/address/json';
const azureKey = process.env.REACT_APP_AZURE_API_KEY;

export const useAzureMaps = () => {
  const getCounty = useCallback(async(fullAddress: string) => {
    const url = `${AZURE_MAPS_API_GEOCODER_URL}?subscription-key=${azureKey}&api-version=1.0&query=${fullAddress}&language=en-US&countrySet=US&limit=1&minFuzzyLevel=2`;

    return axios.get(url)
      .then((response) => {
        const county = response.data?.results[0]?.address?.countrySecondarySubdivision;

        return county?.replace('County', '').trim();
      })
      .catch((error) => {
        console.error('Error fetching data:', error);
      });
  }, []);

  return {
    getCounty
  };
};
